// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-card{display:flex;justify-content:center;width:100%}.container-card>.p-card{max-width:700px!important;margin-top:150px;width:100%}", ""]);
// Exports
module.exports = exports;
